export const supportApiBase = process.env.REACT_APP_API_URL_V2 + "/v2/support";
export const mediaApiBase = process.env.REACT_APP_API_URL_V2 + "/v2/support/media";
